import locale from "@/helpers/locale";
export const seatList = [
  {
    type: "general",
    name: locale("theatre.seat.general")
  },
  {
    type: "vip",
    name: locale("theatre.seat.vip")
  },
  {
    type: "special",
    name: locale("theatre.seat.special")
  },
  {
    type: "close",
    name: locale("theatre.seat.stopsale")
  },
  {
    type: "posCounter",
    name: locale("theatre.seat.windowSeat")
  },
  {
    type: "lovers",
    name: locale("rules.loversSeat")
  },
  {
    type: "wheelchair",
    name: locale("rules.wheelchair")
  }
];
export const deviceList = [
  {
    label: locale("global.POS"),
    value: "POS",
  },
  {
    label: locale("global.scanner"),
    value: "SCANNER",
  },
  {
    label: locale("global.online"),
    value: "WEB",
  },
  {
    label: locale("global.selfCashier"),
    value: "SELFCASHIER",
  }
];